import {ApolloQueryResult} from '@apollo/client';

import {updateAntibodyUIOpenVersionId} from 'antibodies/hooks/useAntibodyUIState';
import {AntibodyHistoryQuery} from 'antibodies/panels/__generated/AntibodyHistoryQuery';
import {ANTIBODY_HISTORY_QUERY} from 'antibodies/panels/AntibodyHistoryPanelView';
import * as EventConstants from 'constants/EventConstants';
import {SchemaTag} from 'folder-items/FileConstants';
import {getApolloClient} from 'graphql-client/ApolloClient';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';

/**
 * Callback after creating a new version of an antibody after an update.
 * Opens the new version and updates the tags.
 */
export function onUpdateAntibodyVersion(
  antibodyId: string,
  newVersionId: string,
  tags: Array<SchemaTag>
): void {
  updateAntibodyUIOpenVersionId(antibodyId, newVersionId);
  notifications.success('Saved antibody');
  requeryAntibodyHistory(antibodyId);
  AppDispatcher.dispatch({
    actionType: EventConstants.FILE_TAGS_UPDATED,
    tagData: [{id: antibodyId, tags}],
  });
}

async function requeryAntibodyHistory(antibodyId: string): Promise<ApolloQueryResult<AntibodyHistoryQuery>> {
  return await getApolloClient().query({
    query: ANTIBODY_HISTORY_QUERY,
    variables: {antibodyId},
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });
}
